import React from "react";
import { Button, Tooltip } from "antd";
import { BiUndo } from "react-icons/bi";
import { useHistory } from "react-router-dom";
import style from "./index.module.scss";

interface CourseHeaderProps {
    title: string;
    info?: React.ReactNode;
    extra?: React.ReactNode;
}

export default function CourseHeader({
    title,
    info,
    extra
}: CourseHeaderProps) {
    const history = useHistory();

    return (
        <div className={style.root}>
            <div className={style.wrapper}>
                <div className={style.left}>
                    <h1 className={style.title}>
                        <Tooltip title={title} placement="bottomLeft">
                            <span>{title}</span>
                        </Tooltip>

                        <Button
                            className={style.back}
                            onClick={() => history.goBack()}>
                            <BiUndo size={16} /> 返回
                        </Button>
                    </h1>

                    <div className={style.info}>{info}</div>
                </div>

                <div className={style.right}>{extra}</div>
            </div>
        </div>
    );
}
